export const IMAGE_MAX_UPLOAD_SIZE = 3000000;
export const IMAGE_UPLOAD_ALLOWED_FILE_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];